module.exports = __webpack_public_path__ + "img/Assets-iPhonelabel.d7627f73.jpg";